module.exports = __webpack_public_path__ + "static/media/logoFile.f6087b43.png";